'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef, useState } from 'react';
export const useShowScrollButtons = () => {
  const $ = _c(5);
  const scrollAreaRef = useRef(null);
  const measureBeforeRef = useRef(null);
  const measureAfterRef = useRef(null);
  const [showBeforeButton, setShowBeforeButton] = useState(undefined);
  const [showAfterButton, setShowAfterButton] = useState(undefined);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const scrollAreaElement = scrollAreaRef.current;
      const beforeElement = measureBeforeRef.current;
      const afterElement = measureAfterRef.current;
      if (scrollAreaElement == null || beforeElement == null || afterElement == null) {
        return;
      }
      const intersectionObserver = new IntersectionObserver(entries => {
        for (const entry of entries) {
          if (entry.target === beforeElement) {
            setShowBeforeButton(!entry.isIntersecting);
          }
          if (entry.target === afterElement) {
            setShowAfterButton(!entry.isIntersecting);
          }
        }
      }, {
        root: scrollAreaElement
      });
      intersectionObserver.observe(beforeElement);
      intersectionObserver.observe(afterElement);
      return () => {
        intersectionObserver.disconnect();
      };
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  if ($[2] !== showAfterButton || $[3] !== showBeforeButton) {
    t2 = {
      scrollAreaRef,
      measureBeforeRef,
      measureAfterRef,
      showBeforeButton,
      showAfterButton
    };
    $[2] = showAfterButton;
    $[3] = showBeforeButton;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};